<template>
  <div>
    <el-row class="dataCards" :gutter="10" type="flex">
      <el-col :md="12" :lg="4.8" style="display: flex;">
        <el-card class="dataCard review smallCardPadding" shadow="hover" style="position: relative;">
          <div style="position: absolute; top: 8px; right: 8px;">
            <div style="width: 35px; height: 35px; border-radius: 100%; background: rgba(236, 0, 140, .8); ">
              <i style="float:left; font-weight: 200; margin: -7px 0px 0px -4px; font-size: 42px; color: #ffffff;" class="mdi mdi-resistor"></i>
            </div>
          </div>
          <el-row type="flex" align="middle">
            <el-col :span="18">
              <span class="dataTitle">{{ topCardSmallStats.length ? topCardSmallStats[0].title : '' }}</span>
              <span class="dataText">{{ topCardSmallStats.length ? topCardSmallStats[0].data : '' }}</span>
              <span class="dataFooter">{{ topCardSmallStats.length ? topCardSmallStats[0].footer : 'No Data Available' }}</span>
            </el-col>
          </el-row>
        </el-card>
      </el-col>
      <el-col :md="12" :lg="4.8" style="display: flex;">
        <el-card class="dataCard review smallCardPadding" shadow="hover" style="position: relative;">
          <div style="position: absolute; top: 8px; right: 8px;">
            <div style="width: 35px; height: 35px; border-radius: 100%; background: rgba(236, 0, 140, .8); ">
              <i style="float:left; font-weight: 200; margin: -7px 0px 0px -4px; font-size: 42px; color: #ffffff;" class="mdi mdi-resistor"></i>
            </div>
          </div>
          <el-row type="flex" align="middle">
            <el-col :span="18">
              <span class="dataTitle">{{ topCardSmallStats.length ? topCardSmallStats[1].title : '' }}</span>
              <span class="dataText"
                >{{ topCardSmallStats.length ? `${topCardSmallStats[1].data}` : '' }}
                <span style="font-weight: 100;">{{ topCardSmallStats.length ? '|' : '' }} </span>
                {{ topCardSmallStats.length ? ` ${((topCardSmallStats[1].data / topCardSmallStats[0].data) * 100).toFixed(0)} %` : '' }}</span
              >
              <span class="dataFooter">{{ topCardSmallStats.length ? topCardSmallStats[1].footer : 'No Data Available' }}</span>
            </el-col>
          </el-row>
        </el-card>
      </el-col>
      <el-col :md="12" :lg="4.8" style="display: flex;">
        <el-card class="dataCard review smallCardPadding" shadow="hover" style="position: relative;">
          <div style="position: absolute; top: 8px; right: 8px;">
            <div style="width: 35px; height: 35px; border-radius: 100%; background: rgba(236, 0, 140, .8); ">
              <i style="float:left; font-weight: 200; margin: -7px 0px 0px -4px; font-size: 42px; color: #ffffff;" class="mdi mdi-resistor"></i>
            </div>
          </div>
          <el-row type="flex" align="middle">
            <el-col :span="18">
              <span class="dataTitle">{{ topCardSmallStats.length ? topCardSmallStats[3].title : '' }}</span>
              <span :class="negativeClass(3)">{{ topCardSmallStats.length ? moneyFormatter(topCardSmallStats[3].data) : '' }}</span>
              <span class="dataFooter">{{ topCardSmallStats.length ? topCardSmallStats[3].footer : 'No Data Available' }}</span>
            </el-col>
          </el-row>
        </el-card>
      </el-col>
      <el-col :md="12" :lg="4.8" style="display: flex;">
        <el-card class="dataCard review smallCardPadding" shadow="hover" style="position: relative;">
          <div style="position: absolute; top: 8px; right: 8px;">
            <div style="width: 35px; height: 35px; border-radius: 100%; background: rgba(236, 0, 140, .8); ">
              <i style="float:left; font-weight: 200; margin: -7px 0px 0px -4px; font-size: 42px; color: #ffffff;" class="mdi mdi-resistor"></i>
            </div>
          </div>
          <el-row type="flex" align="middle">
            <el-col :span="18">
              <span class="dataTitle">{{ topCardSmallStats.length ? topCardSmallStats[2].title : '' }}</span>
              <span :class="negativeClass(2)">{{ topCardSmallStats.length ? moneyFormatter(topCardSmallStats[2].data) : '' }}</span>
              <span class="dataFooter">{{ topCardSmallStats.length ? topCardSmallStats[2].footer : 'No Data Available' }}</span>
            </el-col>
          </el-row>
        </el-card>
      </el-col>
      <el-col :md="12" :lg="4.8" style="display: flex;">
        <el-card class="dataCard review smallCardPadding" shadow="hover" style="position: relative;">
          <div style="position: absolute; top: 8px; right: 8px;">
            <div style="width: 35px; height: 35px; border-radius: 100%; background: rgba(236, 0, 140, .8); ">
              <i style="float:left; font-weight: 200; margin: -7px 0px 0px -4px; font-size: 42px; color: #ffffff;" class="mdi mdi-resistor"></i>
            </div>
          </div>
          <el-row type="flex" align="middle">
            <el-col :span="18">
              <span class="dataTitle">{{ topCardSmallStats.length && topCardSmallStats[4] ? topCardSmallStats[4].title : '' }}</span>
              <span v-if="caseMixIndexData" class="dataText" style="font-size: 25px;">
                <span :class="{ negativeNumber: parseFloat(caseMixIndexData.diff) < 0 }">{{ parseFloat(caseMixIndexData.diff) > 0 ? '+' : '' }}{{ caseMixIndexData.diff }}</span>
                <span style="font-weight: 100;"> | </span>
                <span>{{ caseMixIndexData.chgs }}</span>
              </span>
              <span v-else class="dataText"></span>
              <span class="dataFooter">{{ topCardSmallStats.length && topCardSmallStats[4] ? topCardSmallStats[4].footer : 'No Data Available' }}</span>
            </el-col>
          </el-row>
        </el-card>
      </el-col>
    </el-row>
    <el-row :gutter="10">
      <el-col :span="24" style="margin: 10px 0px 0px 0px; text-align:left;">
        <el-card class=" reviewCard" shadow="hover" style="min-height: 350px;">
          <div slot="header">
            <span>Project Data</span>
            <span class="expandCollapseButton" :title="` ${isClosed ? 'collapse' : 'expand'} section`" @click="expandCollapse"><i :class="`mdi ${isClosed ? 'mdi-arrow-collapse' : 'mdi-arrow-expand'}`"></i></span>
          </div>
          <div class="reviewTableData" v-loading="loading" element-loading-spinner="nucleus-loader">
            <el-row class="dashboardControlsRow">
              <div class="groupingFilterControls">
                <div class="groupingControl">
                  <label style="display: block; font-size: 12px; margin: 0px 0px 5px 0px;">Group Data By:</label>
                  <el-select :disabled="reviewDashboardData.length === 0" :default-first-option="true" placeholder="Group Data by" @change="handleGroupDataSelectChange" :value="inpatientGrouping" filterable>
                    <el-option v-for="item in dropdown" :key="item.key" :label="item.value" :value="item.key"> </el-option>
                  </el-select>
                </div>
                <div class="filterEditorContainer">
                  <el-popover :value="isFilterEditorVisibleForGrouping(currentGroupingValue)" placement="bottom-start" width="320" trigger="click" @input="handleFilterEditorVisibilityChange(currentGroupingValue, $event)">
                    <div class="filterEditorPopover" v-loading="filterEditorLoading" element-loading-spinner="nucleus-loader">
                      <div class="filterEditorTitle">{{ editingGroupingConfig ? `${editingGroupingConfig.label} Filters` : 'Filter Group' }}</div>
                      <el-select :ref="getFilterGroupRefName(currentGroupingValue)" :key="getFilterGroupRefName(currentGroupingValue)" :disabled="!dropDownGroups.length" style="width: 100%;" :default-first-option="true" v-model="pendingSelectedGrouping" placeholder="Filter Group" multiple filterable clearable collapse-tags>
                        <el-option v-for="item in dropDownGroups" :key="item.key" :label="item.value" :value="item.key"> </el-option>
                      </el-select>
                      <div v-if="editingGroupingStickyFilter" class="filterEditorActions">
                        <el-button type="text" @click="clearCurrentGroupingFilterFromPopover">Clear {{ editingGroupingConfig ? editingGroupingConfig.label : 'Filter' }}</el-button>
                      </div>
                    </div>
                    <span slot="reference" class="filterEditorTrigger">
                      <div v-if="currentGroupingStickyFilter" class="filterChip clickableFilterChip activeFilterChip" :title="formatStickyGroupingFilter(currentGroupingStickyFilter)">
                        <span class="truncatedFilterChipLabel">{{ formatStickyGroupingFilter(currentGroupingStickyFilter) }}</span>
                        <span class="currentFilterChipClose" title="Clear filter" @click.stop.prevent="clearCurrentGroupingFilterQuick">
                          <i class="mdi mdi-close"></i>
                        </span>
                      </div>
                      <div v-else class="filterChip clickableFilterChip placeholderFilterChip">
                        +
                        <i class="mdi mdi-filter-outline"></i>
                      </div>
                    </span>
                  </el-popover>
                </div>
                <div v-if="otherStickyGroupingFilters.length" class="inlineStickyFilters">
                  <el-popover v-for="filter in otherStickyGroupingFilters" :key="filter.grouping" :value="isFilterEditorVisibleForGrouping(filter.grouping)" placement="bottom-start" width="320" trigger="click" @input="handleFilterEditorVisibilityChange(filter.grouping, $event)">
                    <div class="filterEditorPopover" v-loading="filterEditorLoading" element-loading-spinner="nucleus-loader">
                      <div class="filterEditorTitle">{{ editingGroupingConfig ? `${editingGroupingConfig.label} Filters` : 'Filter Group' }}</div>
                      <el-select :ref="getFilterGroupRefName(filter.grouping)" :key="getFilterGroupRefName(filter.grouping)" :disabled="!dropDownGroups.length" style="width: 100%;" :default-first-option="true" v-model="pendingSelectedGrouping" placeholder="Filter Group" multiple filterable clearable collapse-tags>
                        <el-option v-for="item in dropDownGroups" :key="item.key" :label="item.value" :value="item.key"> </el-option>
                      </el-select>
                      <div v-if="editingGroupingStickyFilter" class="filterEditorActions">
                        <el-button type="text" @click="clearCurrentGroupingFilterFromPopover">Clear {{ editingGroupingConfig ? editingGroupingConfig.label : 'Filter' }}</el-button>
                      </div>
                    </div>
                    <span slot="reference" class="filterEditorTrigger">
                      <div class="filterChip inlineStickyFilterChip clickableFilterChip passiveFilterChip" :title="formatStickyGroupingFilter(filter)">
                        <span class="truncatedFilterChipLabel">{{ formatStickyGroupingFilter(filter) }}</span>
                        <button type="button" class="stickyFilterChipClose" title="Clear filter" @click.stop.prevent="clearStickyGroupingFilter(filter.grouping)">
                          <i class="mdi mdi-close"></i>
                        </button>
                      </div>
                    </span>
                  </el-popover>
                </div>
              </div>
              <div class="rightControlActions">
                <div class="searchControl">
                  <el-input prefix-icon="el-icon-search" size="mini" placeholder="Search Query.." type="text" class="globalSearch" v-model="filterCriteria" @keyup.native="filterGroupUpdate"></el-input>
                </div>
                <div class="menuControl">
                  <el-dropdown class="tableOptions" title="Table Options" trigger="click" @command="actionMenuCommands" size="medium">
                    <span class="el-dropdown-link">
                      <i class="mdi mdi-dots-horizontal ellipsesIcon"></i>
                    </span>
                    <el-dropdown-menu slot="dropdown" style="width: 160px;" class="documentActionMenu">
                      <el-dropdown-item :command="{ action: 'toggleChartData' }"><i style="margin-right: 6px;" :class="toggleChartData ? 'mdi mdi-chart-bar-stacked' : 'mdi mdi-table-large'"></i>{{ toggleChartData ? 'Toggle Chart' : 'Toggle Data' }} </el-dropdown-item>
                      <el-dropdown-item :command="{ action: 'downloadCSV' }"><i class="mdi mdi-file-download-outline tableIcon"></i>Download CSV </el-dropdown-item>
                      <el-dropdown-item :command="{ action: 'comparisonAccounts' }">
                        <el-checkbox class="bedSizeCompare" :disabled="!reviewDashboardData.length > 0" v-model="activateComparison" @input="handleActivateComparison">Bed Size Compare</el-checkbox>
                      </el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                </div>
              </div>
            </el-row>
            <el-row v-if="activateComparison">
              <div style="float: left; margin: 10px 0px 10px 0px;">
                <label style="display: block; font-size: 12px; margin: 0px 0px 5px 0px;">Bed Size Range:</label>
                <el-select :default-first-option="true" v-model="bedSize" placeholder="Bed Size" @change="handleBedSizeChange()" filterable>
                  <el-option v-for="item in bedSizeDropdown" :key="item.key" :label="item.value" :value="item.key"> </el-option>
                </el-select>
              </div>
              <div style="float: left; margin: 0px 0px 10px 0px; width: 250px;">
                <div style="float: left; width: 30%; text-align: center;">
                  <i :title="`${currentClient} data`" style="font-size: 23px; margin: 0px 0px 0px 0px; color: rgba(19, 86, 149, .8);" class="mdi mdi-set-center"></i>
                  <span style="display: block; font-size: 12px; color: #303133;">{{ `${currentClient}` }}<br />reviews</span>
                </div>
                <div style="float: left; width: 30%; text-align: center;">
                  <i title="HIA bed size data" style="font-size: 23px; margin: 0px 0px 0px 0px; color: #67C23A;" class="mdi mdi-set-center-right"></i>
                  <span style="display: block; font-size: 12px; color: #303133;">{{ bedSize }} bed size reviews</span>
                </div>
                <div style="float: left; width: 30%; text-align: center;">
                  <i title="All HIA bed size data" style="font-size: 23px; margin: 0px 0px 0px 0px; color: rgba(236, 0, 140, 0.8);" class="mdi mdi-set-all"></i>
                  <span style="display: block; font-size: 12px; color: #303133;">All bed size reviews</span>
                </div>
              </div>
            </el-row>
            <el-row>
              <InpatientTables :class="toggleChartData ? 'vshow' : 'vhide'" ref="ipTables" :grouping="inpatientGrouping" :filterCriteria="filterCriteria" :selectedGrouping="selectedGrouping" :activateComparison="activateComparison" :bedSize="bedSize"> </InpatientTables>
              <InpatientCharts :class="!toggleChartData ? 'vshow' : 'vhide'" :grouping="inpatientGrouping" :filterCriteria="filterCriteria" :isClosed="isClosed" :selectedGrouping="selectedGrouping"> </InpatientCharts>
            </el-row>
          </div>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import HiaAuthorization from '@/mixins/hiaAuthorization'
import money from '@/mixins/money'
import { mapState, mapActions, mapMutations } from 'vuex'
import InpatientTables from '@/views/Dashboards/InpatientTables'
import InpatientCharts from '@/views/Dashboards/InpatientCharts'
import hiaFilters from '@/mixins/hiaFilters'
import csvGenerator from '@/mixins/csvGenerator'
import createStickyGroupingMixin from '@/mixins/reviewDashboardStickyGrouping'
import { format } from 'date-fns'

import { createHelpers } from 'vuex-map-fields'

const { mapFields } = createHelpers({
  getterType: 'dashboard/getField',
  mutationType: 'dashboard/updateField'
})

const INPATIENT_GROUPING_CONFIG = {
  '1': { title: 'By Coder', key: 'coder', label: 'Coder' },
  '19': { title: 'By Coder Trending', key: 'coder', label: 'Coder Trending' },
  '2': { title: 'By CDI Staff', key: 'cdiStaff', label: 'CDI Staff' },
  '3': { title: 'By DRGs', key: 'orDrg', label: 'DRG' },
  '4': { title: 'By Patient Type', key: 'patTypeDesc', label: 'Patient Type' },
  '6': { title: 'By Reason', key: 'changeReason', label: 'Reason' },
  '7': { title: 'By Facility', key: 'cliName', label: 'Facility' },
  '8': { title: 'By Dx', key: 'code', label: 'Dx' },
  '18': { title: 'By SDOH Dx', key: 'code', label: 'SDOH' },
  '9': { title: 'By Px', key: 'code', label: 'Px' },
  '10': { title: 'By CC', key: 'code', label: 'CC' },
  '11': { title: 'By MCC', key: 'code', label: 'MCC' },
  '12': { title: 'By HAC', key: 'code', label: 'HAC' },
  '13': { title: 'By HCC', key: 'code', label: 'HCC V24' },
  '17': { title: 'By HCC V28', key: 'code', label: 'HCC V28' },
  '14': { title: 'By PSI', key: 'shortDescription', label: 'PSI' },
  '15': { title: 'By QM Mortality', key: 'shortDescription', label: 'QM Mortality' },
  '16': { title: 'By QM Readmission', key: 'shortDescription', label: 'QM Readmission' },
  '20': { title: 'By Service Line', key: 'clientServiceLineName', label: 'Service Line' },
  '21': { title: 'SOI', key: 'origValue', label: 'SOI Summary' },
  '22': { title: 'ROM', key: 'origValue', label: 'ROM Summary' }
}

const stickyGroupingMixin = createStickyGroupingMixin({
  groupingField: 'inpatientGrouping',
  stickyFiltersField: 'inpatientStickyGroupingFilters',
  dashboardDataField: 'ipData',
  groupingConfigMap: INPATIENT_GROUPING_CONFIG,
  fetchDashboardMethod: 'fetchInpatientGroupingDashboard',
  loadGroupingMethod: 'loadInpatientGrouping'
})

export default {
  data: function() {
    return {
      loading: false,
      filterCriteria: '',
      grouping: '7',
      dropdown: [
        { key: '1', value: 'Coder' },
        { key: '19', value: 'Coder Trending' },
        // { key: '2', value: 'CDI Staff' },
        { key: '3', value: 'DRG' },
        { key: '4', value: 'Patient Type' },
        { key: '6', value: 'Reason' },
        { key: '7', value: 'Facility' },
        { key: '21', value: 'SOI Summary' },
        { key: '22', value: 'ROM Summary' },
        { key: '20', value: 'Service Line' },
        { key: '8', value: 'Dx' },
        { key: '18', value: 'SDOH' },
        { key: '10', value: 'CC' },
        { key: '11', value: 'MCC' },
        { key: '12', value: 'HAC' },
        { key: '13', value: 'HCC V24' },
        { key: '17', value: 'HCC V28' },
        { key: '9', value: 'Px' },
        { key: '14', value: 'PSI' },
        { key: '15', value: 'QM Mortality' },
        { key: '16', value: 'QM Readmission' }
      ],
      selectedRows: [],
      toggleChartData: true,
      toggleExpandCollapse: false,
      groupKey: '',
      selectedGrouping: [],
      activateComparison: false,
      bedSize: '0 - 99'
    }
  },
  name: 'ReviewDashboard',
  mixins: [HiaAuthorization, money, hiaFilters, csvGenerator, stickyGroupingMixin],
  props: {
    isClosed: { type: Boolean },
    bedSizeDropdown: { type: Array },
    dateRange: { type: Array }
  },
  components: {
    InpatientTables,
    InpatientCharts
  },
  methods: {
    ...mapActions('dashboard/', ['GET_DASHBOARD_PROJECTS', 'GET_DASHBOARD_COMPARISON_ACCOUNTS', 'GET_DASHBOARD_COMPARISON_ACCOUNTS_IP_ALL', 'GET_DASHBOARD_COMPARISON_ACCOUNTS_IP_BEDSIZE', 'POST_REVIEW_DASHBOARD_IP']),
    ...mapMutations('dashboard/', ['SET_IP_REVIEW_DASHBOARD', 'SET_DASHBOARD_COMPARISON_ACCOUNTS_BEDSIZE', 'SET_DASHBOARD_COMPARISON_ACCOUNTS']),
    moneyFormatter(value) {
      return `$${this.formatMoney(value)}`
    },
    negativeClass(i) {
      if (this.topCardSmallStats.length) {
        return this.topCardSmallStats[i].data < 0 ? 'dataText negative' : 'dataText'
      }
      return 'dataText'
    },
    handleToggleChartData() {
      this.toggleChartData = !this.toggleChartData
    },
    buildInpatientRequestPayload(grouping, selectedAccountNumbers = this.getCombinedStickyAccountNumbers()) {
      return {
        startDate: this.dateRange[0],
        endDate: this.dateRange[1],
        projects: this.selectedProjects,
        inpatientGrouping: grouping,
        selectedAccountNumbers
      }
    },
    fetchInpatientGroupingDashboard(grouping, selectedAccountNumbers = null) {
      if (this.selectedProjects.length <= 0) {
        return Promise.resolve(null)
      }

      return this.POST_REVIEW_DASHBOARD_IP(this.buildInpatientRequestPayload(grouping, selectedAccountNumbers)).then(response => response.data[0] || null)
    },
    applyInpatientGroupingResponse(newValue, mainClientResponse) {
      let tasks = []

      if (this.activateComparison) {
        let minDate = format(new Date(Math.min.apply(null, this.selectedProjects.map(x => new Date(x.startDate)))), 'MM-dd-yyyy')
        let maxDate = format(new Date(Math.max.apply(null, this.selectedProjects.map(x => new Date(x.endDate)))), 'MM-dd-yyyy')

        let payload = {
          grouping: newValue,
          startDate: minDate,
          endDate: maxDate,
          bedSize: this.bedSize,
          allData: false,
          reviewType: 'ip',
          groupList: this.getGroupDropDown(newValue),
          codeTypes: [],
          noMutation: true
        }

        tasks.push(this.GET_DASHBOARD_COMPARISON_ACCOUNTS_IP_BEDSIZE(payload))

        let payloadCopy = JSON.parse(JSON.stringify(payload))
        payloadCopy.bedSize = 'all'
        payloadCopy.allData = true
        tasks.push(this.GET_DASHBOARD_COMPARISON_ACCOUNTS_IP_ALL(payloadCopy))
      }

      if (tasks.length > 0) {
        return Promise.all(tasks).then(
          response => {
            this.loading = false
            this.inpatientGrouping = newValue
            this.$nextTick(() => {
              this.SET_DASHBOARD_COMPARISON_ACCOUNTS_BEDSIZE(response[0].data)
              this.SET_DASHBOARD_COMPARISON_ACCOUNTS(response[1].data)
              this.SET_IP_REVIEW_DASHBOARD(mainClientResponse)
            })
          },
          e => {
            if (e.response && e.response.data) {
              if (e.response.data.status === 502) {
                this.$message({
                  type: 'error',
                  message: 'Request included a large data set and timed out, please try again',
                  duration: 10000
                })
              }
              this.outpatientGrouping = newValue
              this.loading = false
            }
          }
        )
      }

      this.loading = false
      this.inpatientGrouping = newValue
      this.$nextTick(() => {
        this.SET_IP_REVIEW_DASHBOARD(mainClientResponse)
      })

      return Promise.resolve()
    },
    loadInpatientGrouping(newValue, mainClientResponseOverride) {
      if (this.selectedProjects.length <= 0) {
        this.inpatientGrouping = newValue
        return Promise.resolve()
      }

      this.loading = true
      if (mainClientResponseOverride !== undefined) {
        return this.applyInpatientGroupingResponse(newValue, mainClientResponseOverride)
      }

      let payload = this.buildInpatientRequestPayload(newValue)

      return this.POST_REVIEW_DASHBOARD_IP(payload).then(response => this.applyInpatientGroupingResponse(newValue, response.data[0]))
    },
    handleGroupDataSelectChange(newValue) {
      this.filterCriteria = ''

      this.loadInpatientGrouping(newValue)
    },
    expandCollapse() {
      this.toggleExpandCollapse = !this.toggleExpandCollapse
      this.$emit('expandCollapse', null)
    },
    handledrgGrouping(val) {
      if (val.toString().includes('selectAll')) {
        // this.codeTypeGrouping = this.codeTypeDropdown.map(x => x.key)
      }
    },
    handleArrayToCsv() {
      // let headers = []
      switch (this.inpatientGrouping) {
        case '1':
          this.tableToCsv(this.$refs.ipTables.$refs.coderTable.$el, 'coder_table.csv', [])
          break
        case '19':
          this.tableToCsv(this.$refs.ipTables.$refs.coderTrendingTable.$el, 'coderTrending_table.csv', [])
          break
        case '2':
          this.tableToCsv(this.$refs.ipTables.$refs.cdiStaffTable.$el, 'cdistaff_table.csv', [], this.activateComparison, this.currentClient)
          break
        case '3':
          this.tableToCsv(this.$refs.ipTables.$refs.drgTable.$el, 'drg_table.csv', [], this.activateComparison, this.currentClient)
          break
        case '4':
          this.tableToCsv(this.$refs.ipTables.$refs.patientTypeTable.$el, 'patienttype_table.csv', [], this.activateComparison, this.currentClient)
          break
        case '6':
          this.tableToCsv(this.$refs.ipTables.$refs.reasonTable.$el, 'reason_table.csv', [], this.activateComparison, this.currentClient)
          break
        case '7':
          this.tableToCsv(this.$refs.ipTables.$refs.facilityTable.$el, 'facility_table.csv', [], this.activateComparison, this.currentClient, false)
          break
        case '8':
          this.paginationArrayToCsv('dx')
          break
        case '18':
          this.paginationArrayToCsv('sdoh')
          break
        case '9':
          this.paginationArrayToCsv('px')
          break
        case '13':
          this.tableToCsv(this.$refs.ipTables.$refs.HCCTable.$el, 'hccv24_table.csv', [], this.activateComparison, this.currentClient, false)
          break
        case '17':
          this.tableToCsv(this.$refs.ipTables.$refs.HCCV28Table.$el, 'hccv28_table.csv', [], this.activateComparison, this.currentClient, false)
          break
        case '14':
          this.tableToCsv(this.$refs.ipTables.$refs.psiTable.$el, 'patient_safety_indicators.csv', [], this.activateComparison, this.currentClient, false)
          break
        case '15':
          this.tableToCsv(this.$refs.ipTables.$refs.qmMortalityTable.$el, 'mortality_quality_meaasures.csv', [], this.activateComparison, this.currentClient, false)
          break
        case '16':
          this.tableToCsv(this.$refs.ipTables.$refs.qmReadmissionTable.$el, 'readmission_quality_measures.csv', [], this.activateComparison, this.currentClient, false)
          break
        case '20':
          this.tableToCsv(this.$refs.ipTables.$refs.serviceLineTable.$el, 'serviceLine_table.csv', [])
          break
      }
    },
    actionMenuCommands(object) {
      if (object.action === 'toggleChartData') {
        this.handleToggleChartData()
      }
      if (object.action === 'downloadCSV') {
        this.handleArrayToCsv()
      }
    },
    groupDropDownFilter(data, currentTable, key) {
      return data.filter(x => {
        if (currentTable.some(y => y[key].toString() === x.key.toString())) {
          return x
        }
      })
    },
    handleActivateComparison() {
      if (this.activateComparison && !this.comparisonAccounts.length) {
        this.handleGetDashboardComparisonAccounts(true)
      }
    },
    handleBedSizeChange() {
      this.handleGetDashboardComparisonAccounts(false)
    },
    handleGetDashboardComparisonAccounts(allData) {
      let minDate = format(new Date(Math.min.apply(null, this.selectedProjects.map(x => new Date(x.startDate)))), 'MM-dd-yyyy')
      let maxDate = format(new Date(Math.max.apply(null, this.selectedProjects.map(x => new Date(x.endDate)))), 'MM-dd-yyyy')

      let payload = {
        grouping: this.inpatientGrouping,
        startDate: minDate,
        endDate: maxDate,
        bedSize: this.bedSize,
        allData: allData,
        reviewType: 'ip',
        groupList: this.getGroupDropDown(this.inpatientGrouping),
        codeTypes: []
      }

      this.$emit('comparisonLoading', true)

      let tasks = []
      // always get the bedsize data
      tasks.push(this.GET_DASHBOARD_COMPARISON_ACCOUNTS_IP_BEDSIZE(payload))
      if (allData) {
        // only sometimes get All
        let payloadCopy = JSON.parse(JSON.stringify(payload))
        payloadCopy.bedSize = 'all'
        tasks.push(this.GET_DASHBOARD_COMPARISON_ACCOUNTS_IP_ALL(payloadCopy))
      }

      Promise.all(tasks).then(
        response => {
          this.$emit('comparisonLoading', false)
        },
        e => {
          if (e.response && e.response.data) {
            if (e.response.data.status === 502) {
              this.$message({
                type: 'error',
                message: 'Request included a large data set and timed out, please try again',
                duration: 10000
              })
            }
            this.$emit('comparisonLoading', false)
          }
        }
      )
    },

    getTableData(grouping) {
      if (!this.reviewDashboardData) {
        return []
      }

      let ipIndex = this.reviewDashboardData.findIndex(x => x.type === 'inpatient') > -1 ? this.reviewDashboardData.findIndex(x => x.type === 'inpatient') : null
      if (ipIndex !== null && this.reviewDashboardData[ipIndex].largeStats) {
        let groupIndex = this.reviewDashboardData[ipIndex].largeStats.findIndex(x => x.title === grouping)
        let data = this.reviewDashboardData[ipIndex].largeStats.some(x => x.title === grouping) ? this.reviewDashboardData[ipIndex].largeStats[groupIndex].data : []

        if (this.filterCriteria.length) {
          data = this.filterList(data, this.filterCriteria)
        }

        if (this.selectedGrouping.length) {
          let groupKey = this.reviewDashboardData[ipIndex].largeStats.some(x => x.title === grouping) ? this.reviewDashboardData[ipIndex].largeStats[groupIndex].groupKey : ''
          data = data.filter(x => {
            let val
            this.selectedGrouping.forEach(y => {
              if (x[groupKey].toString() === y.toString()) {
                val = x
              }
            })
            return val
          })
        }

        return data
      }
      return []
    },
    filterGroupUpdate() {
      this.$nextTick(() => {
        const grouping = this.getActiveFilterEditorGrouping()
        const sourceDashboard = this.getFilterGroupSelectionSourceDashboard(grouping)
        const { config, rows } = this.getStickyScopeSourceRows(grouping, sourceDashboard)
        if (!config) {
          this.dropDownGroups = []
          return
        }

        let filteredRows = rows
        if (this.filterCriteria.length) {
          filteredRows = this.filterList(filteredRows, this.filterCriteria)
        }

        this.dropDownGroups = this.groupDropDownFilter(this.getFilterGroupOptions(grouping, sourceDashboard), filteredRows, config.key)
      })
    },
    groupDropDown(grouping = this.inpatientGrouping) {
      return this.getFilterGroupOptions(grouping)
    },
    getGroupDropDown(grouping) {
      let ipIndex = this.reviewDashboardData.findIndex(x => x.type === 'inpatient') > -1 ? this.reviewDashboardData.findIndex(x => x.type === 'inpatient') : null
      if (ipIndex !== null && this.reviewDashboardData[ipIndex].largeStats) {
        let groupIndex
        let data = []
        switch (grouping) {
          case '1':
            groupIndex = this.reviewDashboardData[ipIndex].largeStats.findIndex(x => x.title === 'By Coder')
            if (groupIndex !== -1) {
              data = this.reviewDashboardData[ipIndex].largeStats[groupIndex].groupList ? this.reviewDashboardData[ipIndex].largeStats[groupIndex].groupList : []
            }
            break
          case '19':
            groupIndex = this.reviewDashboardData[ipIndex].largeStats.findIndex(x => x.title === 'By Coder Trending')
            if (groupIndex !== -1) {
              data = this.reviewDashboardData[ipIndex].largeStats[groupIndex].groupList ? this.reviewDashboardData[ipIndex].largeStats[groupIndex].groupList : []
            }
            break
          case '2':
            groupIndex = this.reviewDashboardData[ipIndex].largeStats.findIndex(x => x.title === 'By CDI Staff')
            if (groupIndex !== -1) {
              data = this.reviewDashboardData[ipIndex].largeStats[groupIndex].groupList ? this.reviewDashboardData[ipIndex].largeStats[groupIndex].groupList : []
            }
            break
          case '3':
            groupIndex = this.reviewDashboardData[ipIndex].largeStats.findIndex(x => x.title === 'By DRGs')
            if (groupIndex !== -1) {
              data = this.reviewDashboardData[ipIndex].largeStats[groupIndex].groupList ? this.reviewDashboardData[ipIndex].largeStats[groupIndex].groupList : []
            }
            break
          case '4':
            groupIndex = this.reviewDashboardData[ipIndex].largeStats.findIndex(x => x.title === 'By Patient Type')
            if (groupIndex !== -1) {
              data = this.reviewDashboardData[ipIndex].largeStats[groupIndex].groupList ? this.reviewDashboardData[ipIndex].largeStats[groupIndex].groupList : []
            }
            break
          case '6':
            groupIndex = this.reviewDashboardData[ipIndex].largeStats.findIndex(x => x.title === 'By Reason')
            if (groupIndex !== -1) {
              data = this.reviewDashboardData[ipIndex].largeStats[groupIndex].groupList ? this.reviewDashboardData[ipIndex].largeStats[groupIndex].groupList : []
            }
            break
          case '7':
            groupIndex = this.reviewDashboardData[ipIndex].largeStats.findIndex(x => x.title === 'By Facility')
            if (groupIndex !== -1) {
              data = this.reviewDashboardData[ipIndex].largeStats[groupIndex].groupList ? this.reviewDashboardData[ipIndex].largeStats[groupIndex].groupList : []
            }
            break
          case '8':
            groupIndex = this.reviewDashboardData[ipIndex].largeStats.findIndex(x => x.title === 'By Dx')
            if (groupIndex !== -1) {
              data = this.reviewDashboardData[ipIndex].largeStats[groupIndex].groupList ? this.reviewDashboardData[ipIndex].largeStats[groupIndex].groupList : []
            }
            break
          case '18':
            groupIndex = this.reviewDashboardData[ipIndex].largeStats.findIndex(x => x.title === 'By SDOH Dx')
            if (groupIndex !== -1) {
              data = this.reviewDashboardData[ipIndex].largeStats[groupIndex].groupList ? this.reviewDashboardData[ipIndex].largeStats[groupIndex].groupList : []
            }
            break
          case '9':
            groupIndex = this.reviewDashboardData[ipIndex].largeStats.findIndex(x => x.title === 'By Px')
            if (groupIndex !== -1) {
              data = this.reviewDashboardData[ipIndex].largeStats[groupIndex].groupList ? this.reviewDashboardData[ipIndex].largeStats[groupIndex].groupList : []
            }
            break
          case '10':
            groupIndex = this.reviewDashboardData[ipIndex].largeStats.findIndex(x => x.title === 'By CC')
            if (groupIndex !== -1) {
              data = this.reviewDashboardData[ipIndex].largeStats[groupIndex].groupList ? this.reviewDashboardData[ipIndex].largeStats[groupIndex].groupList : []
            }
            break
          case '11':
            groupIndex = this.reviewDashboardData[ipIndex].largeStats.findIndex(x => x.title === 'By MCC')
            if (groupIndex !== -1) {
              data = this.reviewDashboardData[ipIndex].largeStats[groupIndex].groupList ? this.reviewDashboardData[ipIndex].largeStats[groupIndex].groupList : []
            }
            break
          case '12':
            groupIndex = this.reviewDashboardData[ipIndex].largeStats.findIndex(x => x.title === 'By HAC')
            if (groupIndex !== -1) {
              data = this.reviewDashboardData[ipIndex].largeStats[groupIndex].groupList ? this.reviewDashboardData[ipIndex].largeStats[groupIndex].groupList : []
            }
            break
          case '13':
            groupIndex = this.reviewDashboardData[ipIndex].largeStats.findIndex(x => x.title === 'By HCC')
            if (groupIndex !== -1) {
              data = this.reviewDashboardData[ipIndex].largeStats[groupIndex].groupList ? this.reviewDashboardData[ipIndex].largeStats[groupIndex].groupList : []
            }
            break
          case '17':
            groupIndex = this.reviewDashboardData[ipIndex].largeStats.findIndex(x => x.title === 'By HCC V28')
            if (groupIndex !== -1) {
              data = this.reviewDashboardData[ipIndex].largeStats[groupIndex].groupList ? this.reviewDashboardData[ipIndex].largeStats[groupIndex].groupList : []
            }
            break
          case '14':
            groupIndex = this.reviewDashboardData[ipIndex].largeStats.findIndex(x => x.title === 'By PSI')
            if (groupIndex !== -1) {
              data = this.reviewDashboardData[ipIndex].largeStats[groupIndex].groupList ? this.reviewDashboardData[ipIndex].largeStats[groupIndex].groupList : []
            }
            break
          case '15':
            groupIndex = this.reviewDashboardData[ipIndex].largeStats.findIndex(x => x.title === 'By QM Mortality')
            if (groupIndex !== -1) {
              data = this.reviewDashboardData[ipIndex].largeStats[groupIndex].groupList ? this.reviewDashboardData[ipIndex].largeStats[groupIndex].groupList : []
            }
            break
          case '16':
            groupIndex = this.reviewDashboardData[ipIndex].largeStats.findIndex(x => x.title === 'By QM Readmission')
            if (groupIndex !== -1) {
              data = this.reviewDashboardData[ipIndex].largeStats[groupIndex].groupList ? this.reviewDashboardData[ipIndex].largeStats[groupIndex].groupList : []
            }
            break
          case '20':
            groupIndex = this.reviewDashboardData[ipIndex].largeStats.findIndex(x => x.title === 'By Service Line')
            if (groupIndex !== -1) {
              data = this.reviewDashboardData[ipIndex].largeStats[groupIndex].groupList ? this.reviewDashboardData[ipIndex].largeStats[groupIndex].groupList : []
            }
            break
        }
        return data
      }
      return []
    },
    paginationArrayToCsv(table) {
      let data = []
      let comparsionData = []
      let headers = []
      let keys = []
      let summaryRow = {}

      switch (table) {
        case 'dx':
          data = Object.assign([], this.$refs.ipTables.dxTableData)
          keys = Object.keys(data[0])
          data = data.map((x, i) => {
            let item = {}
            keys.forEach(j => {
              item[j] = x[j]
            })
            // update specifics
            item.poaCodes = this.$refs.ipTables.totalPercentSummaries('poaCodes', [x], 0, { label: 'POA Accuracy Rate' })
            item.cmCodes = this.$refs.ipTables.totalPercentSummaries('cmCodes', [x], 0, { label: 'Accuracy Rate' })

            if (this.activateComparison) {
              let child1 = item
              let child2 = Object.assign({}, item)
              let child3 = Object.assign({}, item)
              // set bedsize
              child1.compare = `${this.currentClient} data`

              child2.compare = 'HIA bed size data'
              child2.code = this.$refs.ipTables.getBedSizeValue('code', child1.code, 'code', false, 'dx')
              child2.description = this.$refs.ipTables.getBedSizeValue('code', child1.code, 'description', false, 'dx')
              child2.totalRecords = this.$refs.ipTables.getBedSizeValue('code', child1.code, 'totalRecords', false, 'dx')
              child2.cmCodes = this.$refs.ipTables.getBedSizeValue('code', child1.code, 'cmCodes', false, 'dx')
              child2.poaCodes = this.$refs.ipTables.getBedSizeValue('code', child1.code, 'poaCodes', false, 'dx')
              child2.isAHacCode = this.$refs.ipTables.getBedSizeValue('code', child1.code, 'isAHacCode', false, 'dx')

              child3.compare = 'All HIA bed size data'
              child3.code = this.$refs.ipTables.getBedSizeValue('code', child1.code, 'code', true, 'dx')
              child3.description = this.$refs.ipTables.getBedSizeValue('code', child1.code, 'description', true, 'dx')
              child3.totalRecords = this.$refs.ipTables.getBedSizeValue('code', child1.code, 'totalRecords', true, 'dx')
              child3.cmCodes = this.$refs.ipTables.getBedSizeValue('code', child1.code, 'cmCodes', true, 'dx')
              child3.poaCodes = this.$refs.ipTables.getBedSizeValue('code', child1.code, 'poaCodes', true, 'dx')
              child3.isAHacCode = this.$refs.ipTables.getBedSizeValue('code', child1.code, 'isAHacCode', true, 'dx')

              comparsionData.push(child1, child2, child3)
            }

            return item
          })

          // build summary row
          keys.forEach(j => {
            summaryRow[j] = ''
          })
          // update specifics
          summaryRow.isAHacCode = this.$refs.ipTables.totalHACSummary('isAHacCode', data, 0)
          summaryRow.poaCodes = this.$refs.ipTables.totalPercentSummaries('poaCodes', data, 0, { label: 'POA Accuracy Rate' })
          summaryRow.cmCodes = this.$refs.ipTables.totalPercentSummaries('cmCodes', data, 0, { label: 'Accuracy Rate' })
          summaryRow.totalRecords = this.$refs.ipTables.totalSummary('totalRecords', data, 0)

          // build headers
          headers = [{ key: 'code', value: 'Code' }, { key: 'description', value: 'Description' }, { key: 'totalRecords', value: 'Total Records' }, { key: 'cmCodes', value: 'Accuracy Rate' }, { key: 'poaCodes', value: 'POA Accuracy Rate' }, { key: 'isAHacCode', value: 'Potential HAC' }]

          if (this.activateComparison) {
            headers.unshift({ key: 'compare', value: ' ' })
            summaryRow.compare = `${this.currentClient} data summary`
            data = comparsionData
          }

          data.push(summaryRow)
          this.arrayToCsv(data, 'dx_table.csv', headers)
          break
        case 'sdoh':
          data = Object.assign([], this.$refs.ipTables.sdohTableData)
          keys = Object.keys(data[0])
          data = data.map((x, i) => {
            let item = {}
            keys.forEach(j => {
              item[j] = x[j]
            })
            // update specifics
            item.poaCodes = this.$refs.ipTables.totalPercentSummaries('poaCodes', [x], 0, { label: 'POA Accuracy Rate' })
            item.cmCodes = this.$refs.ipTables.totalPercentSummaries('cmCodes', [x], 0, { label: 'Accuracy Rate' })

            if (this.activateComparison) {
              let child1 = item
              let child2 = Object.assign({}, item)
              let child3 = Object.assign({}, item)
              // set bedsize
              child1.compare = `${this.currentClient} data`

              child2.compare = 'HIA bed size data'
              child2.code = this.$refs.ipTables.getBedSizeValue('code', child1.code, 'code', false, 'dx')
              child2.description = this.$refs.ipTables.getBedSizeValue('code', child1.code, 'description', false, 'dx')
              child2.totalRecords = this.$refs.ipTables.getBedSizeValue('code', child1.code, 'totalRecords', false, 'dx')
              child2.cmCodes = this.$refs.ipTables.getBedSizeValue('code', child1.code, 'cmCodes', false, 'dx')
              child2.poaCodes = this.$refs.ipTables.getBedSizeValue('code', child1.code, 'poaCodes', false, 'dx')
              child2.isAHacCode = this.$refs.ipTables.getBedSizeValue('code', child1.code, 'isAHacCode', false, 'dx')

              child3.compare = 'All HIA bed size data'
              child3.code = this.$refs.ipTables.getBedSizeValue('code', child1.code, 'code', true, 'dx')
              child3.description = this.$refs.ipTables.getBedSizeValue('code', child1.code, 'description', true, 'dx')
              child3.totalRecords = this.$refs.ipTables.getBedSizeValue('code', child1.code, 'totalRecords', true, 'dx')
              child3.cmCodes = this.$refs.ipTables.getBedSizeValue('code', child1.code, 'cmCodes', true, 'dx')
              child3.poaCodes = this.$refs.ipTables.getBedSizeValue('code', child1.code, 'poaCodes', true, 'dx')
              child3.isAHacCode = this.$refs.ipTables.getBedSizeValue('code', child1.code, 'isAHacCode', true, 'dx')

              comparsionData.push(child1, child2, child3)
            }

            return item
          })

          // build summary row
          keys.forEach(j => {
            summaryRow[j] = ''
          })
          // update specifics
          summaryRow.isAHacCode = this.$refs.ipTables.totalHACSummary('isAHacCode', data, 0)
          summaryRow.poaCodes = this.$refs.ipTables.totalPercentSummaries('poaCodes', data, 0, { label: 'POA Accuracy Rate' })
          summaryRow.cmCodes = this.$refs.ipTables.totalPercentSummaries('cmCodes', data, 0, { label: 'Accuracy Rate' })
          summaryRow.totalRecords = this.$refs.ipTables.totalSummary('totalRecords', data, 0)

          // build headers
          headers = [{ key: 'code', value: 'Code' }, { key: 'description', value: 'Description' }, { key: 'totalRecords', value: 'Total Records' }, { key: 'cmCodes', value: 'Accuracy Rate' }, { key: 'poaCodes', value: 'POA Accuracy Rate' }, { key: 'isAHacCode', value: 'Potential HAC' }]

          if (this.activateComparison) {
            headers.unshift({ key: 'compare', value: ' ' })
            summaryRow.compare = `${this.currentClient} data summary`
            data = comparsionData
          }

          data.push(summaryRow)
          this.arrayToCsv(data, 'sdoh_table.csv', headers)
          break
        case 'px':
          data = Object.assign([], this.$refs.ipTables.pxTableData)
          keys = Object.keys(data[0])
          data = data.map((x, i) => {
            let item = {}
            keys.forEach(j => {
              item[j] = x[j]
            })

            // update specifics
            item.pcsCodes = this.$refs.ipTables.totalPercentSummaries('pcsCodes', [x], 0, { label: 'Accuracy Rate' })

            // add comparison title
            if (this.activateComparison) {
              let child1 = item
              let child2 = Object.assign({}, item)
              let child3 = Object.assign({}, item)
              // set bedsize
              child1.compare = `${this.currentClient} data`

              child2.compare = 'HIA bed size data'
              child2.code = this.$refs.ipTables.getBedSizeValue('code', child1.code, 'code', false, 'px')
              child2.description = this.$refs.ipTables.getBedSizeValue('code', child1.code, 'description', false, 'px')
              child2.totalRecords = this.$refs.ipTables.getBedSizeValue('code', child1.code, 'totalRecords', false, 'px')
              child2.pcsCodes = this.$refs.ipTables.getBedSizeValue('code', child1.code, 'pcsCodes', false, 'px')

              child3.compare = 'All HIA bed size data'
              child3.code = this.$refs.ipTables.getBedSizeValue('code', child1.code, 'code', true, 'px')
              child3.description = this.$refs.ipTables.getBedSizeValue('code', child1.code, 'description', true, 'px')
              child3.totalRecords = this.$refs.ipTables.getBedSizeValue('code', child1.code, 'totalRecords', true, 'px')
              child3.pcsCodes = this.$refs.ipTables.getBedSizeValue('code', child1.code, 'pcsCodes', true, 'px')

              comparsionData.push(child1, child2, child3)
            }

            return item
          })

          // build summary row
          keys.forEach(j => {
            summaryRow[j] = ''
          })
          // update specifics
          summaryRow.pcsCodes = this.$refs.ipTables.totalPercentSummaries('pcsCodes', data, 0, { label: 'Accuracy Rate' })
          summaryRow.totalRecords = this.$refs.ipTables.totalSummary('totalRecords', data, 0)

          // build headers
          headers = [{ key: 'code', value: 'Code' }, { key: 'description', value: 'Description' }, { key: 'pcsCodes', value: 'Accuracy Rate' }, { key: 'totalRecords', value: 'Total Records' }]

          //  add comparison header/summary
          if (this.activateComparison) {
            headers.unshift({ key: 'compare', value: ' ' })
            summaryRow.compare = `${this.currentClient} data summary`
            data = comparsionData
          }

          data.push(summaryRow)
          this.arrayToCsv(data, 'px_table.csv', headers)
          break
      }
    }
  },
  created: function() {},
  mounted: function() {},
  watch: {
    inpatientGrouping() {
      this.openFilterEditorGrouping = null
      this.resetFilterGroupSelectionSource()
      this.dropDownGroups = this.groupDropDown()
      this.setCurrentGroupingSelections()
      this.setFilterEditorSelections(this.inpatientGrouping)
    },
    ipData() {
      const grouping = this.getActiveFilterEditorGrouping()
      this.dropDownGroups = this.getFilterGroupOptions(grouping, this.getFilterGroupSelectionSourceDashboard(grouping))
    }
  },
  computed: {
    ...mapState('user/', ['currentClient', 'currentClientId']),
    ...mapState('dashboard/', ['dashboardData', 'dashboardProjects', 'reviewDashboardData', 'comparisonAccounts', 'selectedProjects', 'inpatientGrouping', 'reviewDashboardBaselineSmallStatsIP']),
    ...mapFields(['inpatientGrouping', 'inpatientStickyGroupingFilters']),
    topCardSmallStats() {
      return this.reviewDashboardBaselineSmallStatsIP
    },
    caseMixIndexData() {
      if (!this.topCardSmallStats.length || !this.topCardSmallStats[4]) return null
      const parts = this.topCardSmallStats[4].data.split('|')
      return {
        org: parts[0] || '',
        rec: parts[1] || '',
        diff: parts[2] || '',
        chgs: parts[3] || ''
      }
    },
    ipData() {
      let ipIndex = this.reviewDashboardData.findIndex(x => x.type === 'inpatient') > -1 ? this.reviewDashboardData.findIndex(x => x.type === 'inpatient') : null
      if (ipIndex !== null) {
        return [this.reviewDashboardData[ipIndex]]
      }
      return []
    }
  }
}
</script>

<style>
.el-col-lg-4\.8 {
  width: 20% !important;
}
</style>

<style scoped>
#reviewTabs {
  margin: 0px 0px 0px 0px;
}

#reviewTabs >>> .el-tabs__nav-wrap::after {
  background-color: transparent;
}

>>> .projectsClosed {
  width: 0%;
  visibility: hidden;
}

>>> .projectsOpen {
  /* visibility: visible;
    width: 20.83333%; */
}

>>> .reviewGridClosed {
  /* width: 100%; */
}

>>> .reviewGridOpen {
  /* width: 77.17%; */
}

>>> .togglePaneClosed {
  /* border-left: 1px solid rgb(235, 238, 245);
    border-top-left-radius: 4px;
    border-bottom-left-radius: 4px; */
}

#reviewLargeStat1 >>> .el-checkbox__inner {
  border-radius: 10px;
}

#projectPane:hover ~ #togglePane > #togglePaneRow {
  /* webkit-box-shadow: 0 2px 12px -3px rgba(0, 0, 0, 0.1);
    box-shadow: 0 2px 12px -3px rgba(0, 0, 0, 0.1); */
}

.reviewTableData >>> .el-table--striped .el-table__body tr.el-table__row--striped td {
  /* background: rgb(238, 238, 238); */
}

.tableIcon {
  font-size: 16px;
  float: left;
  height: 12px;
  margin: -3px 5px 0 0;
}

.cmi-table {
  width: 100%;
  border-collapse: collapse;
  margin: 4px 0;
  font-size: 13px;
  text-align: center;
}

.cmi-table th {
  font-weight: 600;
  color: #909399;
  padding: 2px 4px;
  border-bottom: 1px solid #ebeef5;
}

.cmi-table td {
  padding: 2px 4px;
  color: #303133;
  font-weight: 500;
}
</style>
